import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import apiReceipt from "@/api/receipt";
import helperReceipt from "@/helpers/receipt";
import dashboardApi from "../../../api/dashboard";

const defaultState = () => ({
	listReceipt: [],
	pagination: '',
	detailSO: {},
	detailReceipt: {},
	konfirmResponse: {},
	responSukses: '',
	dataSerial: helperReceipt.getSerialData(),
	serialInvalid: [],
	sold_platform: ['pos', 'store'],
	dataPurchaseOrder: {
        dibuat: 0,
        dibayar: 0,
        diproses: 0,
        dikirim: 0,
        selesai: 0,
		refund: 0,
    },
});

const state = defaultState();

const getters = {};

const mutations = {
	setReceipt(state, data) {
		state.listReceipt = data.data;
		state.pagination = data.pagination;
	},
	setDetailSO(state, data) {
		state.detailSO = data.results;
	},
	setDetailReceipt(state, data) {
    data.results.detail.map(el => {
      el.serialProduct = {};
      state.sold_platform.forEach(platform => {
        el.serialProduct[platform] = {
          quantity: 0,
          serial: [],
        }
      });
      return el
    });
		state.detailReceipt = data.results
	},
	refreshListSerial(state) {
		state.dataSerial = helperReceipt.getSerialData()
	},
	setSerialInvalid(state, data) {
		state.serialInvalid = data
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = {};
		state.konfirmResponse = data;
	},
	konfirmasiSukses(state, data) {
		state.responSukses = '';
		state.responSukses = data;
	},
	listPurchaseOrder(state, data) {
        state.dataPurchaseOrder.dibuat = data.dibuat 
        state.dataPurchaseOrder.dibayar = data.dibayar
        state.dataPurchaseOrder.diproses = data.diproses
        state.dataPurchaseOrder.dikirim = data.dikirim 
        state.dataPurchaseOrder.selesai = data.selesai 
        state.dataPurchaseOrder.refund = data.refund
    },
};

const actions = {
	getReceipt({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		commit(PROGRESS_START, null, { root: true });
		apiReceipt.getReceipt(param).then(({ data: { data } }) => {
			if (data.results.length == 0) {
				commit('setReceipt', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
			} else {
				commit("setReceipt", { data: data.results, pagination: data.pagination });
			}
			commit(PROGRESS_FINISH, null, { root: true });
		});
	},
	getDetailSO({ commit }, param) {
		return new Promise (async (resolve, reject) => {
			commit("setDetailSO", {});
			commit(PROGRESS_START, null, { root: true });
			apiReceipt.getDetailSO(param).then(({ data: { data } }) => {
				commit("setDetailSO", data);
				commit(PROGRESS_FINISH, null, { root: true });
				resolve()
			}).catch(({response: { data } }) => {
				reject(data.message)
			});
		})
	},
	getDetailReceipt({ commit }, param) {
		return new Promise (async (resolve, reject) => {
			commit(PROGRESS_START, null, { root: true });
			apiReceipt.getDetailReceipt(param).then(({ data: { data } }) => {
				commit("setDetailReceipt", data);
				commit(PROGRESS_FINISH, null, { root: true });
				resolve()
			}).catch(res => {
        reject(res)
      });
      // .catch(({response: { data } }) => {
			// 	reject(data.message)
			// });
		})
	},
	async addReceipt({ commit }, value) {
		return new Promise (async (resolve, reject) => {
			commit("konfirmasiSukses", '');
			commit(PROGRESS_START, null, { root: true });
			await apiReceipt.addReceipt(value).then(res => {
				const data = res.data.code;
				commit("konfirmasiSukses", data);
				resolve()
			}).catch( ({response: { data } }) => {
				if (data.message == 'error_validation') {
					const res = data.data
					commit("saveConfirmResponse", res);
				} else {
					commit("saveConfirmResponse", {
						sdo_code: data.message
					});
				}
				reject()
			});
		})
	},
	getSerialStashed({ commit }, value) {
		return new Promise (async (resolve, reject) => {
			await apiReceipt.getSerialStashed(value).then(res => {
				const data = res.data;
				if (data.data.results) {
					// var serial_stashed = helperReceipt.getSerialData()
					var serial = {
						sdo_id: value.sdo_id,
						product_id: value.product_id,
						product_is_serial: value.product_is_serial,
						serial: data.data.results
					}
					helperReceipt.setSerialData(serial)
				}
				commit("konfirmasiSukses", data.code);
				resolve(true)
			}).catch(err => {
				const data = err.response.data
				commit("saveConfirmResponse", data);
				reject(true)
			})
		})
	},
	syncSerial({ commit }, {value, index}) {
		return new Promise (async (resolve, reject) => {
			commit("konfirmasiSukses", '');
			commit(PROGRESS_START, null, { root: true });
			// var serial = await helperReceipt.getSerialData()
			// var sdo = serial.findIndex(el => el.sdo_id == value.sdo_id)
			await apiReceipt.syncSerial(value).then(res => {
				const data = res.data.code;
				commit("konfirmasiSukses", data);
				/*kalau ga ada yang valid, muncul alert, alert bawa index yang dari input form, klik oke di alert, hilangkan data di input form nya*/
				var serial_invalid = res.data.data.serial_invalid.map(el => el.serial)
				if (serial_invalid.length > 0) {
					reject(true)
					commit('setSerialInvalid', index)
				} else {
					resolve(true)
				}
			}).catch(err => {
				if (err.response) {
					reject(true)
					const data = err.response.data
					commit("saveConfirmResponse", data);
				}
			});
			await commit('refreshListSerial');
			await commit(PROGRESS_FINISH, null, { root: true });
		})
	},
	async proccessSerial({ commit }, value) {
		return new Promise (async (resolve, reject) => {
			commit("konfirmasiSukses", '');
			commit(PROGRESS_START, null, { root: true });
			await apiReceipt.proccessSerial(value).then(res => {
				helperReceipt.setSerialData(null)
				const data = res.data.code;
				commit("konfirmasiSukses", data);
				resolve()
			}).catch(err => {
				const data = err.response.data.message
				reject(data)
				commit("saveConfirmResponse", data);
			});
		})
	},
	async cancelSO({ commit }, value) {
		return new Promise (async (resolve, reject) => {
			commit("konfirmasiSukses", '');
			commit(PROGRESS_START, null, { root: true });
			await apiReceipt.cancelSO(value).then(res => {
				const data = res.data.code;
				commit("konfirmasiSukses", data);
				resolve()
			}).catch(err => {
				const data = err.response.data.message
				reject(data)
				commit("saveConfirmResponse", data);
			});
			commit(PROGRESS_FINISH, null, { root: true });
		})
	},
	getPurchaseOrder({ commit }) {
		commit(PROGRESS_START, null, { root: true });
		dashboardApi.getPurchaseOrder().then(({ data: { data } }) => {
			if (data.length == 0) {
				commit("listPurchaseOrder", 'error');
			} else {
				commit("listPurchaseOrder", data.results[0]);
			}
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit("listPurchaseOrder", 'error');
			commit(PROGRESS_FAIL, null, { root: true });
		});
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
